import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import TextInput from "components/Input/TextInput.js";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
import {
  CustomSelect,
} from "components/Input/Index.js";
import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import moment from "moment";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import CustomSwitch from "components/Input/CustomSwitch.js";
import { putMBMIotDevice, postFileUpload, getProfilePicture } from "services/ConfigServices";
import styled from "styled-components";
import { definitionData, updategroupchoiceData, eosprotocoleData, lorawanclassData, concatdlData } from "variables/MBM/lists/iotdevices";
import { iotdevicetext } from "variables/MBM/iotdevices";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters.js";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;
const HeaderId = styled.div`
  font-size: 14px;
  font-weight: 500;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

function IotDialog(props) {
  const memv2versionactive = localStorage.getItem('memv2version') || 0;
  const { closeModal, refetch, setLoading, setNotification, iot } = props;
  const [name, setName] = useState(iot.name || "");
  const [description, setDescription] = useState(iot.name || "");
  const [definition, setDefinition] = useState(iot.definition || "");
  const [otherproperties, setOtherproperties] = useState(iot.otherproperties || {});
  const [connectionproperties, setConnectionproperties] = useState(iot.connectionproperties || {});
  const [eosprotocol, setEosprotocol] = useState(iot.connectionproperties?.eosprotocol || "");
  const [deveui, setDeveui] = useState(iot.connectionproperties?.deveui || "");
  const [concatdl, setConcatdl] = useState(iot.connectionproperties?.concatdl || "");
  const [lorawanclass, setLorawanclass] = useState(iot.connectionproperties?.lorawanclass || "");

  const [groupid, setGroups] = useState(iot.groupid ? "" + iot.groupid : "");
  const [updategroupchoice, setUpdategroupchoice] = useState("iotonly");
  const [groupchanged, setGroupchanged] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const [imageUrl, setImageUrl] = useState(null);
  const [imageCode, setImageCode] = useState(iot.otherproperties?.imageCode || null);
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);

  const selectedDefinition = () => {
    let selected = definitionData.find((obj) => obj.id == definition);
    return selected;
  };

  const handleDefinitionChange = (selected) => { setDefinition(selected?.id || ""); };
  const handleNameChange = (event) => { setName(event.target.value); };
  const handleDescriptionChange = (event) => { setDescription(event.target.value); };
  const handleUpdategroupchoiceChange = (event) => { setUpdategroupchoice(event.target.value); };

  const handleEosprotocolChange = (event) => { setEosprotocol(event.target.value); };
  const handleDeveuiChange = (event) => { setDeveui(event.target.value); };
  const handleConcatdlChange = (event) => { setConcatdl(event.target.value); };
  const handleLorawanclassChange = (event) => { setLorawanclass(event.target.value); };


  const classes = useStyles();


  const handleSubmit = (event) => {
    updateIot(event);
    closeModal();
  };

  useEffect(() => {
    if (imageCode) {
      setImageCode(imageCode);
      setImagePreviewUrl(getProfilePicture(imageCode));
    }
  }, []);

  useEffect(() => {
    if (!name || !definition || !groupid || groupid.length === 0)
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
    if (groupid !== ("" + iot.groupid))
      setGroupchanged(true);
    else
      setGroupchanged(false);
  }, [name, groupid, definition, description]);




  const updateIot = async (event) => {
    axios
      .put(
        putMBMIotDevice(iot.id, groupchanged ? updategroupchoice : "iotonly"),
        {
          ...iot,
          name,
          description,
          definition,
          groupid,
          otherproperties: {
            ...otherproperties,
            imageCode
          },
          connectionproperties: {
            ...connectionproperties,
            eosprotocol,
            deveui,
            concatdl,
            lorawanclass
          }
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Iot modifié");
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        // setLoading(false);
      });
  };

  //Profile picture
  useEffect(() => {
    if (imageUrl) {
      const formData = new FormData();
      // we append each element to the form
      formData.append("files", imageUrl);
      axios
        .post(postFileUpload(groupid, "profilepic"), formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
        .then((res) => {
          //console.log(res.data);
          //console.log(res.data.files[0].url);
          setImageCode(res.data.files[0].url);
          setImagePreviewUrl(getProfilePicture(res.data.files[0].url));
        })
        .catch(() => { });
    }
  }, [imageUrl]);

  return (
    <>

      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={7} lg={7}>
            <HeaderId>Id : {iot.id}</HeaderId>
            <div>
              <TextInput
                inputTitle={iotdevicetext.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={iotdevicetext.description}
                textInput={description}
                handleTextInputChange={handleDescriptionChange}
              />
            </div>
            <div>
              <AutocompleteInputMeters
                specialWidth={"97%"}
                inputMargin={"1rem 0rem 0rem"}
                inputTitle={iotdevicetext.definition}
                selected={selectedDefinition()}
                list={definitionData}
                handleChange={(_, newValue) =>
                  handleDefinitionChange(newValue)
                }
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={iotdevicetext.eosprotocol}
                selectValue={eosprotocol}
                handleSelectValueChange={handleEosprotocolChange}
                data={eosprotocoleData}
              />
            </div>
            <div>
              <TextInput
                inputTitle={iotdevicetext.deveui}
                textInput={deveui}
                handleTextInputChange={handleDeveuiChange}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={iotdevicetext.lorawanclass}
                selectValue={lorawanclass}
                handleSelectValueChange={handleLorawanclassChange}
                data={lorawanclassData}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={iotdevicetext.concatdl}
                selectValue={concatdl}
                handleSelectValueChange={handleConcatdlChange}
                data={concatdlData}
              />
            </div>
            <div style={{ paddingLeft: "8px", paddingTop: "8px" }}>
              <ImageUpload
                file={imageUrl}
                setImageCode={setImageCode}
                setFile={setImageUrl}
                imagePreviewUrl={imagePreviewUrl}
                setImagePreviewUrl={setImagePreviewUrl}
                disabled={!groupid}
              />
            </div>
            {
              groupchanged ?
                <div>
                  <CustomSelect
                    inputTitle={iotdevicetext.updategroupchoice}
                    selectValue={updategroupchoice}
                    handleSelectValueChange={handleUpdategroupchoiceChange}
                    data={updategroupchoiceData}
                  />
                </div>
                : <></>
            }

          </GridItem>
          <GridItem xs={12} sm={6} md={5} lg={5}>
            <div
              className={classes.treeVisible}
            >
              <TreeLabel>Choix du périmètre</TreeLabel>
              <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                <EmbeddedEntitesTree
                  selectedIds={setGroups}
                  userSelectedIds={groupid}
                />
              </ImageList>
            </div>
          </GridItem>
        </GridContainer>
        <Button
          disabled={buttonDisabled}
          className={
            buttonDisabled
              ? classes.submitButtonDisabled
              : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </form>

    </>
  );
}

export default IotDialog;
